import { atomWithStorage } from "jotai/utils";

const navbarCollapsedAtom = atomWithStorage("navbar-collapsed", false, undefined, {
  getOnInit: true,
});

export { navbarCollapsedAtom };
